import { render, staticRenderFns } from "./form-rate.vue?vue&type=template&id=5d259543"
import script from "./form-rate.vue?vue&type=script&lang=js"
export * from "./form-rate.vue?vue&type=script&lang=js"
import style0 from "./form-rate.vue?vue&type=style&index=0&id=5d259543&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports